import React, { FC } from "react";
import {
  Tooltip,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  Paper,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import { useStyles } from "../styles";
import { numberWithCommas } from "utils/numberFormat";

const AppleMusicTop10: FC<{ posts: Array<any> }> = ({ posts }) => {
  const classes = useStyles({});

  return (
    <div id="Apple Music-Top 10 Most Listened Songs">
      <div
        className={classes.statsName}
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "20px",
          padding: "30px 0px 25px 0px",
          fontFamily: "Avenir Book, sans-serif",
          fontWeight: 900,
        }}
      >
        <span>Top 10 Most Listened Songs</span>
        <Tooltip
          title={
            "Top 10 most listened songs on the last week within the selected period. The metrics are for a 7-days period."
          }
          arrow
          interactive
          classes={{ tooltip: classes.info, arrow: classes.arrow }}
        >
          <InfoIcon />
        </Tooltip>
      </div>
      <TableContainer
        component={Paper}
        style={{
          boxShadow: "0px 5px 45px rgba(0, 0, 0, 0.07)",
          borderRadius: "15px",
        }}
      >
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell className={classes.tableCell} align="center">
                Song Title
              </TableCell>
              <TableCell className={classes.tableCell} align="center">
                Plays
              </TableCell>
              <TableCell className={classes.tableCell} align="center">
                Avg. daily listeners
              </TableCell>
              <TableCell className={classes.tableCell} align="center">
                Shazams
              </TableCell>
              <TableCell className={classes.tableCell} align="center">
                Radio Spins
              </TableCell>
              <TableCell className={classes.tableCell} align="center">
                Purchases
              </TableCell>
            </TableRow>
          </TableHead>
          {/* Table Body */}
          <TableBody>
            {posts.map((post) => (
              <TableRow key={post.videoLink} className={classes.row}>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {post.songTitle}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {numberWithCommas(parseInt(post.plays))}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {numberWithCommas(parseInt(post.avgDailyListeners))}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {numberWithCommas(parseInt(post.shazams))}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {numberWithCommas(parseInt(post.radioSpins))}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className={`${classes.post} ${classes.tableCell}`}>
                    <span className={classes.postDetails}>
                      {numberWithCommas(parseInt(post.purchases))}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AppleMusicTop10;
